export const activationSettings = {
  'loaderline': {
    'default': true,
    'ACTION:SETUP': false,
  },
  'IntroScreenEntity-tap-to-play-port-text': {
    'default': false,
    'ACTION:SETUP': true,
  },
  'underloader': {
    'default': true,
    'ACTION:SETUP': false,
  },
  'LoadingEntity': {
    'default': true,
    'ACTION:LOAD': false,
  },
  'close': {
    'default': false,
    'ACTION:SETUP': true,
  },
  'IntroScreenEntity-tap-to-play-text': {
    'default': false,
    'ACTION:SETUP': true,
  },
  'IntroScreenEntity': {
    'default': true,
    'BUTTON:close': false,
  },
  'PopupEntity': {
    'default': false,
    'POPUP:show': true,
    'POPUP:close': false,
  },
  'FreespinsAddEntity': {
    'default': false,
    'STATE:IN:FS-ADD': true,
    'STATE:OUT:FS-ADD': false,
  },
  'FreespinsStartEntity': {
    'default': false,
    'STATE:IN:FS-START': true,
    'STATE:OUT:FS-START': false,
  },
  'FreespinsEndEntity': {
    'default': false,
    'STATE:IN:FS-END': true,
    'STATE:OUT:FS-END': false,
  },
  'ReelsEntity': {
    'default': true,
    'INIT:FREESPINS': false,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-END': true,
  },
  'VolcanReelsEntity': {
    'default': false,
    'INIT:FREESPINS': true,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-ADD': true,
    'STATE:IN:FS-START': false,
    'STATE:OUT:FS-START': true,
    'STATE:IN:FS-END': false,
  },
  'UIGeneralEntity': {
    'default': true,
    'INIT:FREESPINS': true,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-ADD': true,
    'STATE:IN:FS-START': false,
    'STATE:OUT:FS-START': true,
    'STATE:IN:FS-END': false,
    'STATE:OUT:FS-END': true,
  },
  'UIRegularEntity': {
    'default': true,
    'INIT:FREESPINS': false,
    'UI:RG:ENTITY:HIDE': false,
    'UI:RG:ENTITY:SHOW': true,
    'STATE:IN:FS-START': false,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-END': true,
  },
  'UIFreespinsEntity': {
    'default': false,
    'INIT:FREESPINS': true,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-ADD': true,
    'STATE:IN:FS-START': false,
    'STATE:OUT:FS-START': true,
    'STATE:IN:FS-END': false,
  },
  'UIFrameEntity': {
    'default': true,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-ADD': true,
    'STATE:IN:FS-START': false,
    'STATE:OUT:FS-START': true,
    'STATE:IN:FS-END': false,
    'STATE:OUT:FS-END': true,
  },
  'RegularBgrEntity': {
    'default': true,
    'INIT:FREESPINS': false,
    'STATE:IN:FS-ADD': true,
    'STATE:IN:FS-END': true,
    'STATE:IN:FS-START': true,
  },
  'ForegroundRegularEntity': {
    'default': true,
    'INIT:REGULAR': true,
    'INIT:FREESPINS': false,
    'STATE:IN:FS-START': true,
    'STATE:OUT:FS-START': true,
    'STATE:IN:FS-END': true,
  },
  'ForegroundFreespinsEntity': {
    'default': false,
    'INIT:FREESPINS': true,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-ADD': true,
    'STATE:IN:FS-START': false,
    'STATE:OUT:FS-START': false,
    'STATE:IN:FS-END': false,
  },
  'RegularHeaderEntity': {
    'default': true,
    'INIT:FREESPINS': false,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-ADD': false,
    'STATE:IN:FS-START': false,
    'STATE:OUT:FS-START': false,
    'STATE:IN:FS-END': false,
    'STATE:OUT:FS-END': true,
  },
  'FreespinsHeaderEntity': {
    'default': false,
    'INIT:FREESPINS': true,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-ADD': true,
    'STATE:IN:FS-START': false,
    'STATE:OUT:FS-START': true,
    'STATE:IN:FS-END': false,
  },
  'WildEntity': {
    'default': true,
    'STATE:IN:FS-END': false,
    'STATE:OUT:FS-END': true,
  },
  'WinAnimationEntity': {
    'default': false,
    'STATE:OUT:WIN': false,
    'WIN-ANIMATE': true,
  },
  'autostop': {
    'default': false,
    'STATE:IN:AUTO': true,
    'STATE:IN:BET': false,
    'BUTTON:autostop': false,
    'STATE:IN:FB-ADD': false,
  },
  'ui-automenu': {
    'default': true,
    'STATE:IN:AUTO': false,
    'STATE:IN:BET': true,
    'BUTTON:autostop': true,
    'STATE:IN:FB-ADD': false,
    'FREEBET:END': true,
    'STATE:IN:FREE-BET': false,
  },
  'autospin-text': {
    'default': false,
    'STATE:IN:AUTO': true,
    'STATE:IN:BET': false,
    'BUTTON:autostop': false,
    'RADIO:ui': false,
    'RADIO:ui|automenu': true,
  },
  'you-win': {
    'default': false,
    'WIN-COLLECT': true,
    'ACTION:REQUEST-SPIN': false,
    'STATE:IN:FS-ADD': false,
  },
  'OverReelEntity': {
    'default': true,
    'STATE:IN:FS-ADD': false,
    'STATE:OUT:FS-ADD': true,
    'STATE:IN:FS-START': false,
    'STATE:OUT:FS-START': true,
    'STATE:IN:FS-END': false,
    'STATE:OUT:FS-END': true,
  },
  'TextLineEntity': {
    'default': false,
    'ACTION:WIN-SMALL': true,
    'LINES:HIDE': false,
    'LINES:SHOW': true,
  },
  'FreebetEntity': {
    'default': false,
    'fade': true,
    'FREEBET:SHOW:POPUP': true,
    'RADIO:FB': false,
    'FREEBET:END': true,
    'BUTTON:spin': false,
  },
  'fb-add': {
    'default': false,
    'fade': true,
    'FREEBET:SHOW:POPUP': true,
    'RADIO:FB': false,
    'FREEBET:END': false,
  },
  'fb-end': {
    'default': false,
    'fade': true,
    'FREEBET:SHOW:POPUP': false,
    'RADIO:FB': false,
    'FREEBET:END': true,
  },
  'ui-bet': {
    'default': true,
    'fade': true,
    'STATE:IN:FB-ADD': false,
    'FREEBET:END': true,
    'STATE:IN:FREE-BET': false,
  },
  'ui-menu': {
    'default': true,
    'STATE:IN:FB-ADD': false,
    'FREEBET:END': true,
    'STATE:IN:FREE-BET': false,
  },
  'SymbolValueEntity': {
    'default': false,
    'SHOW-SYMBOL-VALUE:IN': true,
    'SHOW-SYMBOL-VALUE:OUT': false,
    'BUTTON:spin': false,
  },
}
